import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { ProviderListComponent } from './provider-list/provider-list.component';
import { ProviderAddComponent } from './provider-add/provider-add.component';
import { ProviderDetailComponent } from './provider-detail/provider-detail.component';
import { ProviderMonthlyComponent } from './provider-monthly/provider-monthly.component';

const routes: Routes = [{
    path: "provider", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
        path: "monthly", component: ProviderMonthlyComponent, data: { module: "Proveedor", accion: "Gestión mensual", type: "monthly" }
    }, {
        path: "list", component: ProviderListComponent, data: { module: "Proveedor", accion: "Listado de proveedores", type: "list" }
    }, {
        path: "add", component: ProviderAddComponent, data: { module: "Proveedor", accion: "Crear proveedor", type: "add" }
    }, {
        path: "update/:id", component: ProviderAddComponent, data: { module: "Proveedor", accion: "Editar proveedor", type: "update" }
    }, {
        path: "view/:id", component: ProviderDetailComponent, data: { module: "Proveedor", accion: "Detalle de proveedor", type: "view" }
    }]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProviderRoutingModule { }
